import { DatePipe, NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BotMessageFeedback } from '@shared/index';
import { BotService } from 'src/app/shared/services/bot.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { MessageBubbleComponent } from '../../../../../../shared/components/ai-bot/utils/bot-chat-dialog/message-bubble/message-bubble.component';
import { FormForBooleanComponent } from '../../../../../../shared/components/ai-bot/utils/form-for-boolean/form-for-boolean.component';
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { MessageModule } from 'primeng/message';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  imports: [NgClass, DatePipe, 
    FormForBooleanComponent,
    FormsModule,
    MessageBubbleComponent,
    ManualLinkComponent,
    MessageModule,
    CardModule,
    ButtonModule
  ],
  templateUrl: './feedback-tab.component.html',
  styleUrl: './feedback-tab.component.scss'
})
export class FeedbackTabComponent implements OnInit {
  public feedback: BotMessageFeedback[] = [];
  public filter: "thumbsup" | "thumbsdown" | "all" = "all";
  public humanFeedback = $localize`:@@active-human-feeback:Menschliches Feedback aktivieren`;

  constructor(
    private bot: BotService,
    public rss: RouteShareService
  ) { }

  public async ngOnInit(): Promise<void> {
    this.feedback = (await this.bot.getFeedback(this.rss.botConfig._id)).feedbacks.reverse();
  }
}
